export const GET_GITHUB_USER_SAGA = 'GET_GITHUB_USER_SAGA';
export const SEARCH_USERS_SAGA = 'SEARCH_USERS_SAGA';
export const SEARCH_INIT_SAGA = 'SEARCH_INIT_SAGA';
export const GET_SEARCHED_USERS_LIST = 'GET_SEARCHED_USERS_LIST';
export const GET_SEARCHED_USER = 'GET_SEARCHED_USER';

export const FETCH_ALL_HISTORY = 'FETCH_ALL_HISTORY';
export const FETCH_SEARCH_HISTORY = 'FETCH_SEARCH_HISTORY';
export const SEARCH_HISTORY_LIST_FLAG = 'SEARCH_HISTORY_LIST_FLAG';
export const SEARCH_HISTORY_MODAL_FLAG = 'SEARCH_HISTORY_MODAL_FLAG';

export const GET_LOCAL_HISTORY_SAGA = 'GET_LOCAL_HISTORY_SAGA';

export const FETCH_LOGIN = 'FETCH_LOGIN';
export const FETCH_USERS_LIST = 'FETCH_USERS_LIST';
export const FETCH_USERS_LIST_SAGA = 'FETCH_USERS_LIST_SAGA';
export const REPOS_LIST_SAGA = 'REPOS_LIST_SAGA';
export const PAGINATION_SAGA = 'PAGINATION_SAGA';
export const PAGINATION_REPOS_SAGA = 'PAGINATION_REPOS_SAGA';
